// extracted by mini-css-extract-plugin
export var qltooltipLauncher = "bp_d7";
export var qltooltipWrapper = "bp_d6";